export enum PersonCredentialApplicationReportFields {
  id = 'id',
  personId = 'personId',
  personCredentialId = 'personCredentialId',
  imageId = 'imageId',
  email = 'email',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  fullName = 'fullName',
  suffix = 'suffix',
  externalSystemId = 'externalSystemId',
  credentialApplicationDefinitionId = 'credentialApplicationDefinitionId',
  credentialApplicationType = 'credentialApplicationType',
  credentialApplicationNumber = 'credentialApplicationNumber',
  credentialApplicationStartDate = 'credentialApplicationStartDate',
  credentialApplicationEndDate = 'credentialApplicationEndDate',
  credentialApplicationUpdatedBy = 'credentialApplicationUpdatedBy',
  credentialApplicationUpdatedOn = 'credentialApplicationUpdatedOn',
  credentialApplicationCreatedOn = 'credentialApplicationCreatedOn',
  credentialDefinitionId = 'credentialDefinitionId',
  credentialName = 'credentialName',
  scenarios = 'scenarios',
  status = 'status',
}
